import Flatpickr from 'flatpickr/dist/flatpickr'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'

const defaultConfig = {
    locale: Dutch,
}

const defaultDateConfig = {
    weekNumbers: true,
}

const defaultTimeConfig = {
    enableTime: true,
    minuteIncrement: 30,
    time_24hr: true,
}

export default class DateTimePicker {
    constructor(element, config) {
        Flatpickr(element, config)
    }

    static initAllDateTimePicker(selector) {
        this.initAll(selector, {
            ...defaultConfig,
            ...defaultDateConfig,
            ...defaultTimeConfig,
            dateFormat: 'd-m-Y H:i',
        })
    }

    static initAllDatePicker(selector) {
        this.initAll(selector, {
            ...defaultConfig,
            ...defaultDateConfig,
            dateFormat: 'd-m-Y',
        })
    }

    static initAllTimePicker(selector) {
        this.initAll(selector, {
            ...defaultConfig,
            ...defaultTimeConfig,
            noCalendar: true,
            dateFormat: 'H:i',
        })
    }

    static initAll(selector, config) {
        Array.from(
            document.querySelectorAll(selector),
            (element) => new DateTimePicker(element, config)
        )
    }
}
